import SignaturePad from 'signature_pad';

$(document).on('turbolinks:load', function() {
  // clicking the signature button
  $('#signatureButton').on('click', function(e) {
    e.preventDefault();

    $('#signatureModal').modal('show');
  });

  // get the canvas element
  var canvas = document.getElementById('signature_pad')
  if (canvas) {
    var signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      penColor: 'rgb(0, 0, 0)'
    });

    $('#signature_save_button').click(function(e) {
      if (signaturePad.isEmpty()) {
        alert('You must sign!')
        e.preventDefault();
      } else {
        // assign the val to the hidden signature input
        $('#collection_signature').val(signaturePad.toDataURL());

        // close modal after clicking save button
        $('#signatureModal').modal('hide');
      }
    });

    $('#clear_button').on('click', function(e) {
      signaturePad.clear();
    });
  }

  // clicking the send button
  $('#sendButton').on('click', function(e) {
    e.preventDefault();

    $('#emailModal').modal('show');
  });

});
